import { render, staticRenderFns } from "./UpdateInvoiceStatusDialog.vue?vue&type=template&id=3324cff4"
import script from "./UpdateInvoiceStatusDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateInvoiceStatusDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports